<template>
  <div>
    <div class="base-tabs" :class="{ 'base-card': isCard }">
      <ul>
        <li
          v-for="(tab, i) in tabs"
          :key="i"
          :class="{ 'is-active': tab.isActive }"
        >
          <a :href="tab.href" @click="selectTab(tab)" v-if="tab.show">
            {{ tab.name }}
          </a>
        </li>
      </ul>
      <slot name="base-tab-header" v-bind="{ tabs }" />
    </div>

    <div class="base-tabs-details" :style="customStyleDetail">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isCard: {
      type: Boolean,
      default: false,
    },
    customStyleDetail: {
      type: Object,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name == selectedTab.name;
      });
    },
  },
};
</script>


<style lang="css" scoped>
.base-card {
  background-color: white;
  border-radius: 8px;
}

.base-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin: 20px 0px 10px 20px; */
}

.line {
  border-left: 1px solid #e7e9f0;
  height: 32px;
}

.base-tabs > ul {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  list-style-type: none;
  font-size: 20px;
  padding: 0px;
  padding-top: 16px;
}

li {
  margin: 0 20px;
  padding-bottom: 10px;
  width: 160px;
  text-align: center;
}

.is-active {
  border-bottom: 2px solid rgba(39, 174, 96, 1);
}

.is-active > a {
  font-weight: 700 !important;
  color: black !important;
}

.base-tabs > ul > li > a {
  font-weight: 400;
  text-decoration: none;
  margin: 0px 20px;
  color: #dbdbdb;
}
</style>
